import axios from 'axios';

export const state = () => ({
    configuration: {
        idpLoginUrl: '',
        idpEntityId: '',
        idpCert: '',
        isActive: false
    },
});

export const getters = {
    configuration: state => state.configuration
};

export const mutations = {
    SET_CONFIGURATION(state, data) {
        state.configuration = data;
    },
};

export const actions = {
    async get({ commit }) {
        const res = await axios.$get(`/v1/admin/business_profiles/preferences/sso/saml`);
        commit('SET_CONFIGURATION', res);
        return res;
    },

    async update({ commit }, data) {
        const res = await axios.$put(`/v1/admin/business_profiles/preferences/sso/saml`, data);
        commit('SET_CONFIGURATION', res);
        return res;
    },
};
